import { useState, useEffect } from 'react';

interface DeviceInfo {
  isDesktop: boolean;
  isMobile: boolean;
  isTablet: boolean;
  hasTouch: boolean;
}

export const useDeviceDetection = (): DeviceInfo => {
  const [deviceInfo, setDeviceInfo] = useState<DeviceInfo>({
    isDesktop: true,
    isMobile: false,
    isTablet: false,
    hasTouch: false
  });

  useEffect(() => {
    const checkDevice = () => {
      const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      const userAgent = navigator.userAgent.toLowerCase();
      const screenWidth = window.innerWidth;
      
      // Mobile detection
      const isMobile = (
        /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(userAgent) ||
        (hasTouch && screenWidth < 768)
      );
      
      // Tablet detection
      const isTablet = (
        /ipad|android(?!.*mobile)|kindle|silk/i.test(userAgent) ||
        (hasTouch && screenWidth >= 768 && screenWidth <= 1024)
      );
      
      // Desktop detection (not mobile and not tablet)
      const isDesktop = !isMobile && !isTablet;
      
      setDeviceInfo({
        isDesktop,
        isMobile,
        isTablet,
        hasTouch
      });
    };

    checkDevice();
    window.addEventListener('resize', checkDevice);
    
    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  return deviceInfo;
};